import React from 'react'
import { IcaCardRow } from '../IcaElements/IcaCardRow'
import { Store } from '../../contexts/store-context'
import ItemCard from './ItemCard'
import { IcaPlaceholder } from '../IcaElements/IcaPlaceholder'
import { SelectedArticles } from '../../types/Picklist'

interface IItemCardProps {
  totalPerItem: SelectedArticles
  sites: Store[]
  selectedArticles: string[]
  handleSelectArticle: (ean: string) => void
  isPending: boolean
  articlesBySite: boolean
  pickDisplay?: string
  loading: boolean
  error: boolean
  articlesByCategory: boolean
  showSingleSiteMaxQuantity: boolean
}

export default function PicklistArticle({ totalPerItem, sites, selectedArticles, handleSelectArticle, isPending, articlesBySite, loading, error, pickDisplay, articlesByCategory, showSingleSiteMaxQuantity, }: IItemCardProps) {
  return (
    <div className={`${selectedArticles.length > 0 ? 'mb-14' : 'mb-2'} ${isPending ? 'opacity-50 pointer-events-none' : ''}`}>
      {(Array.isArray(totalPerItem) && totalPerItem.length > 0) || (Object.entries(totalPerItem).length > 0)? (
        Array.isArray(totalPerItem)
          ? totalPerItem.map((item) => (
            <ItemCard
              key={item.ean} 
              item={item}
              selectedArticles={selectedArticles} 
              handleSelectArticle={handleSelectArticle}
              sites={articlesBySite ? sites : undefined}
              pickDisplay={pickDisplay}
              showSingleSiteMaxQuantity={showSingleSiteMaxQuantity}
            />
          ))
          : Object.entries(totalPerItem).map(
            ([category, items], index) => (
              <div
                key={`item-card-category-${category}-${index}`}
                className='mb-2'
              >
                {articlesByCategory && (
                  <IcaCardRow noninteractive>
                    <h4 className='my-1'>{category}</h4>
                  </IcaCardRow>
                )}
                {items.map((item) => (
                  <ItemCard
                    key={item.ean}
                    item={item}
                    selectedArticles={selectedArticles}
                    handleSelectArticle={handleSelectArticle}
                    sites={articlesBySite ? sites : undefined}
                    pickDisplay={pickDisplay}
                    showSingleSiteMaxQuantity={showSingleSiteMaxQuantity}
                  />
                ))}
              </div>
            )
          )
      ) : (
        !loading && !error && (
          <div className='pt-12 bg-[#F9F5F5]'>
            <IcaPlaceholder
              text='Inga artiklar hittades för din sökning'
              align='center'
            >
              <tgdb-ica-icon-search />
            </IcaPlaceholder>
          </div>
        )
      )}
    </div>
  )
}